import { readState } from "@/__main__/app-state.mjs";
import { postData } from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GQL from "@/feature-auth/fetches/user-client-gql.mjs";
import type { UpdateUserResponse } from "@/feature-auth/models/update-user-response-model.mjs";
import UpdateUserResponseModel from "@/feature-auth/models/update-user-response-model.mjs";
import * as AuthActions from "@/feature-auth/utils/auth-actions.mjs";
import getBearerToken from "@/feature-auth/utils/get-auth-request-header.mjs";
import clone from "@/util/clone.mjs";

export interface UpdateUserInput {
  name?: string;
  birthday?: Date;
  location?: string;
  gender?: string;
}

export async function updateUserInfo(user: UpdateUserInput) {
  const bearerToken = await getBearerToken();

  if (bearerToken) {
    const { updateUser: updatedUser }: UpdateUserResponse = await postData(
      {
        url: appURLs.AUTH_GRAPHQL,
        body: {
          query: GQL.UpdateUser,
          variables: {
            user: {
              ...user,
              birthday: user.birthday ? formatDate(user.birthday) : undefined,
            },
          },
        },
      },
      UpdateUserResponseModel,
      undefined,
      { headers: { Authorization: bearerToken } },
    );

    const clonedUser = clone(readState.user);

    const activeSessions = {
      activeSessions:
        clonedUser && "activeSessions" in clonedUser
          ? clonedUser.activeSessions
          : [],
    };

    AuthActions.setUserAction({
      ...updatedUser,
      ...activeSessions,
    });
  }
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${month <= 9 ? "0" + month : month}-${
    day <= 9 ? "0" + day : day
  }`;
}
